import { render } from "./CustomizationSaveBuildBody.vue?vue&type=template&id=d3876098"
import script from "./CustomizationSaveBuildBody.vue?vue&type=script&lang=js"
export * from "./CustomizationSaveBuildBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__